import ThemedModal from "components/atoms/ThemedModal";
import HelperPrice from "utils/helper/HelperPrice";
import i18n from "utils/i18n";
import Text from "theme/Text";
import Button from "theme/Button";
import { useEffect, useRef, useState } from "react";
import VStack from "components/atoms/stack/VStack";
import React from "react";
import { StyleSheet, View } from "react-native";
import Input from "theme/Input";
import Icon from "components/atoms/Icon";
import { colorList } from "utils/colors";
import HStack from "components/atoms/stack/HStack";
import { layoutStyles } from "styles/layout";
import ThemedBlock from "components/atoms/ThemedBlock";
import InputPlusMin from "components/molecules/InputPlusMin";

const ModalBuy = ({ item, setVisible, onPressConfirmBuy }) => {

    const [ amount, setAmount ] = useState( 1 );

    return (
        <ThemedModal
            visible={ true }
            setVisible={ setVisible }
            title={ i18n.t('page.credits_buy.modal.title') }
                footer={(<>
                    <Button
                        isLoading={ false }
                        appearance="ghost"
                        onPress={ setVisible }>

                        { i18n.t('page.credits_buy.modal.cancel') }
                    </Button>

                    <Button
                        isLoading={ false }
                        onPress={ onPressConfirmBuy.bind( this, amount ) }>

                        { i18n.t('page.credits_buy.modal.confirm') }
                    </Button>
            </>)}>

            <VStack>
                <Text>{ i18n.t('page.credits_buy.modal.description', { amount: item?.credits_amount * amount, price: HelperPrice.format( item?.price * amount ) }) }</Text>

                <View
                    style={ styles.upContainer }>

                    <ThemedBlock
                        mediumPadding
                        shadow>

                        <VStack>
                            <Text style={styles.textTextAlignCenter}>{ i18n.t('page.credits_buy.modal.change_amount', { amount: item?.credits_amount, price: HelperPrice.format( item?.price * amount ) }) }</Text>

                            <InputPlusMin 
                                value={ amount }
                                onChange={ setAmount }
                            />
                        </VStack>
                    </ThemedBlock>
                </View>
            </VStack>
        </ThemedModal>
    )
}

const styles = StyleSheet.create({
	textTextAlignCenter: {
		textAlign: 'center',
	},
    upContainer: {
        marginTop: 8,
        alignItems: 'center',
    },

    upInput: {
        width: 50,
        flex: 1,
        textAlign: 'center',
        height: 'auto'
    }
})

export default ModalBuy;
